import client from '/src/services/client.js';

export default {
    getCategories: () => client.get('admin/criteria/categories', {}),
    createCategory: (data) => client.post('admin/criteria/categories', data),
    updateCategory: (id, data) => client.put(`admin/criteria/categories/${id}`, data),
    deleteCategory: (id) => client.delete(`admin/criteria/categories/${id}`),

    getDefinitions: (params) => client.get('admin/criteria/definitions', params),
    createDefinition: (data) => client.post('admin/criteria/definitions', data),
    updateDefinition: (id, data) => client.put(`admin/criteria/definitions/${id}`, data),
    deleteDefinition: (id) => client.delete(`admin/criteria/definitions/${id}`),
}
